import React from 'react';
import { LegalPage } from './LegalLayout';

const Mentions = () => <LegalPage pageKey="mentions" />;

export default Mentions;
